import _slicedToArray from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
// Copyright 2017-2021 @polkadot/ui-keyring authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { combineLatest } from '@polkadot/x-rxjs';
import { map } from '@polkadot/x-rxjs/operators';
import { accounts } from "./accounts.mjs";
import { addresses } from "./addresses.mjs";
import { contracts } from "./contracts.mjs";
export var obervableAll = combineLatest(accounts.subject, addresses.subject, contracts.subject).pipe(map(function (_ref) {
  var _ref2 = _slicedToArray(_ref, 3),
      accounts = _ref2[0],
      addresses = _ref2[1],
      contracts = _ref2[2];

  return {
    accounts: accounts,
    addresses: addresses,
    contracts: contracts
  };
}));